module.exports = __webpack_public_path__ + "static/img/gallery_3.d9e5573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/gallery_3.png
// module id = 6Vd7
// module chunks = 1